define( [
	"./deletedIds"
], function( deletedIds ) {
	return deletedIds.indexOf;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/indexOf.js
// module id = 350
// module chunks = 1